"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateProgress = void 0;
var react_1 = require("react");
var swr_1 = require("swr");
var keys_1 = require("../keys");
var useUpdateProgress = function () {
    var mutate = (0, swr_1.useSWRConfig)().mutate;
    var update = (0, react_1.useCallback)(function () {
        mutate(keys_1.MY_LEVEL_PROGRESS);
    }, [mutate]);
    return {
        updateProgress: update,
    };
};
exports.useUpdateProgress = useUpdateProgress;
